// extracted by mini-css-extract-plugin
export var emoji = "DefaultImage-module--emoji--c604c";
export var title = "DefaultImage-module--title--7965f";
export var wrapper = "DefaultImage-module--wrapper--b20c1";